<template>
  <div class="fw-bold fs-5">
    {{ progressText }}
    <div class="progress my-3" style="width: 100%">
      <div
        class="progress-bar"
        role="progressbar"
        :style="{ width: progress + '%' }"
        :aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProgressBar',

  props: {
    progress: {
      type: Number,
      required: true,
    },
    progressText: {
      type: String,
      required: true,
    },
  },
});
</script>
